var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTechnicalSupport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#fff",
  opacity: 0.55
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#472179",
  strokeWidth: 1.2,
  d: "M43 18.643c0 2.564-5.82 4.643-13 4.643s-13-2.079-13-4.643m26 0C43 16.079 37.18 14 30 14s-13 2.079-13 4.643m26 0v22.286c0 2.564-5.82 4.642-13 4.642s-13-2.078-13-4.642V18.643m26 7.428c0 2.565-5.82 4.643-13 4.643s-13-2.078-13-4.643M43 33.5c0 2.564-5.82 4.643-13 4.643S17 36.064 17 33.5"
})));
export default SvgTechnicalSupport;